var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3409 4.63636H22.0227H18.5454V1.15908C18.5455 0.519256 18.0274 0 17.3864 0H8.11364C7.47268 0 6.95457 0.519256 6.95457 1.15908V4.63636H3.47728H1.15908C0.518115 4.63636 0 5.15561 0 5.79543C0 6.43525 0.518061 6.95456 1.15908 6.95456H2.31815V24.341C2.31815 26.2581 3.87831 27.8182 5.79543 27.8182H19.7046C21.6217 27.8182 23.1819 26.2581 23.1819 24.341V6.95456H24.3409C24.9819 6.95456 25.5 6.43531 25.5 5.79549C25.5 5.15567 24.9819 4.63636 24.3409 4.63636ZM9.27272 2.31821H16.2273V4.63641H9.27272V2.31821ZM20.8636 24.341C20.8636 24.9796 20.3444 25.5 19.7046 25.5H5.79543C5.15561 25.5 4.63636 24.9796 4.63636 24.341V6.95456H8.11364H17.3864H20.8637V24.341H20.8636Z",
    fill: "#F23154"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27284 9.27277C8.63188 9.27277 8.11377 9.79202 8.11377 10.4318V20.8637C8.11377 21.5035 8.63188 22.0228 9.27284 22.0228C9.91381 22.0228 10.4319 21.5035 10.4319 20.8637V10.4318C10.4319 9.79202 9.91381 9.27277 9.27284 9.27277Z",
    fill: "#F23154"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2269 9.27277C15.586 9.27277 15.0679 9.79202 15.0679 10.4318V20.8637C15.0679 21.5035 15.586 22.0228 16.2269 22.0228C16.8679 22.0228 17.386 21.5035 17.386 20.8637V10.4318C17.386 9.79202 16.8679 9.27277 16.2269 9.27277Z",
    fill: "#F23154"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.0092b74242401ef3dbb63b893f302277.svg";
export { ForwardRef as ReactComponent };